const initialState = {
  newState: false,
  workSpaceDetail: [],
  cloningProgress: 0, 
  clonedSuccessStatus: false, 
  isCollabUser:false,
  isCollabPlan:false,
  socketEventData:{action_type:'clients'},
  introVideo:null,
  cloning_type:"workspace",
  newUserSetting:"",
  isClonedWokspace:false,
  event_name:""
};

export default function workSpaceCloning(state = initialState, action) {
  switch (action.type) {
    case "SET_SPECIAL_USER":

      return {
          ...state,
          newState:state.newState === true ? true :action?.data?.data?.checkSpecialFlag?.special_flagged_agencies,
          introVideo: state?.introVideo && state?.introVideo?.length > 1 ? 
          state.introVideo : 
          action?.data?.data?.planOptions?.intro_video,
          cloning_type:action?.data?.data?.planOptions?.schedule_event ? "schedule":state.cloning_type,
          isClonedWokspace: action?.data?.data?.checkSpecialFlag?.is_dummy_workspace_cloned ? true : false,
          event_name:action?.data?.data?.event_name
      };
      case "SET_SPECIAL_USER_RESET":
        return {
            ...state,
            // newState:0,
            socketEventData:{action_type:'clients'}
        };
        case "CLONE_WORKSPACE_R":
          return {
              ...state,
              workSpaceDetail: action.data,
              cloningProgress: 0, 
          };
      case "CLONE_WORKSPACE_F":
          return {
              ...state,
              workSpaceDetail: action.data,
              cloningProgress: 100, 
          };
          case "CLONE_WORKSPACE_S_70":
            return {
                ...state,
                cloningProgress: 70, 
            };

      case "CLONED_STATUS_S":
          return {
              ...state,
              cloningProgress: 100, 
          };
      case "CLONING_PROGRESS_UPDATE":
          return {
              ...state,
              cloningProgress:action?.progress
          };
        case "CLONING_PROGRESS_UPDATE_C":
          return {
              ...state,
              newState:false,
              
          };
       case "COLLAB_USER_S":
            return {
                ...state,
                isCollabUser:action.data.result
            };
        case "COLLAB_USER_F":
            return {
                ...state,
                isCollabUser:false,
                newState:0
            }; 
        case "CLONING_NOTIFY_DATA":
            return {
                ...state,
                socketEventData:action?.data?.message ? action?.data?.message : action?.data
            }  
        case "CLONING_NOTIFY_DATA_RESET_S":
            return {
                ...state,
                socketEventData:initialState?.socketEventData
            } 
      default:
          return state;
  }
}
